// extracted by mini-css-extract-plugin
export default {"loginRedirect":"loginRedirect-KRvAZ","header":"header-1Undy","body":"body-3AyMg","text":"text-2C3uq","button":"button-2XZ-P"};